import {TemplateComponentModel} from './template-component-model';
import {TemplateModel} from './template-model';
import {TemplateBotaoModel} from './template-botao-model';
import {CodigoIdiomaEnum} from '../../enum/codigo-idioma-enum';
import {TemplateComponenteExemploModel} from './template-componente-exemplo-model';
import {StatusTemplateEnum} from '../../enum/status-template-enum';
import {Usuario} from '../usuario/usuario.model';
import {Conta} from '../conta.model';
import {IdNome} from '../id-nome.model';

export class TemplateSalvamentoModel {

  id: number | null = null;
  name?: string;
  tipo?: string;
  category?: string;
  language?: string;
  status?: StatusTemplateEnum;
  dataCriacao?: Date;
  usuarioCriacao?: Usuario;
  dataAlteracao?: Date;
  usuarioAlteracao?: Usuario;
  components: TemplateComponentModel[] = [];
  conta: Conta = new Conta();
  enviadoMeta = false;
  ativo = false;
  setor?: IdNome;
  utilizado = false;
  variavelFixa = false;

  converterParaEnvio(template: TemplateModel): TemplateSalvamentoModel {
    let cabecalho: TemplateComponentModel;
    let rodape: TemplateComponentModel;
    const btnInterno: TemplateBotaoModel[] = [];
    let botao: TemplateComponentModel;

    const ehSms = (template.tipo || 'WHATSAPP').toUpperCase() === 'SMS';

    this.id = template.id || null;
    this.name = template.nome;
    this.tipo = ehSms ? 'SMS' : 'WHATSAPP';
    this.category = ehSms ? undefined : template.categoria;
    this.language = this.language = template.idiomaAuxString ?? Object.keys(CodigoIdiomaEnum)[0];
    this.dataCriacao = template.dataCriacao;
    this.usuarioCriacao = template.usuarioCriacao;
    this.dataAlteracao = template.dataAlteracao;
    this.usuarioAlteracao = template.usuarioAlteracao;
    this.variavelFixa = !ehSms && !!template.variavelFixa;

    if(!ehSms && (template.templateCabecalho && template.templateCabecalho.titulo || template.templateCabecalho?.file)) {
      if(template.templateCabecalho.textoOuMidia === 'Texto'){
        cabecalho = {
          id: template.templateCabecalho.id,
          type: 'HEADER',
          format: 'TEXT',
          text: template.templateCabecalho.titulo!,
          buttons: [],
          example: []
        }
      }
      else{
        cabecalho = {
          id: template.templateCabecalho.id,
          type: 'HEADER',
          format: template.templateCabecalho?.format,
          text: undefined,
          buttons: [],
          example: [{
            tipo: 'HEADER',
            campo: 'HEADER_HANDLE',
            valor: template.templateCabecalho?.file,
            ordem: null
          }]
        }
      }
    }

    if(!ehSms && template.botoes?.length > 0){
      template.botoes.forEach(btn => {
        switch (btn.type){
          case 'QUICK_REPLY':
            btnInterno.push({
              id: btn.id,
              type: btn.type,
              payload: btn.payload,
              text: btn.text,
              url: "",
              phone_number: ""
            });
            break;
          case 'URL':
            btnInterno.push({
              id: btn.id,
              type: btn.type,
              valor: btn.payload || btn.url,
              text: btn.text,
              url: btn.url,
              phone_number: ""
            });
            break;
          case 'PHONE_NUMBER':
            btnInterno.push({
              id: btn.id,
              type: btn.type,
              payload: btn.payload,
              text: btn.text,
              url: "",
              phone_number: btn.phone_number
            });
            break;
        }
      });

      botao = {
        id: undefined,
        type: 'BUTTONS',
        format: undefined,
        text: undefined,
        buttons: btnInterno,
        example: []
      }
    }

    const corpo: TemplateComponentModel = {
      id: template.variavel?.id,
      type: 'BODY',
      format: undefined,
      text: template.variavel.corpo,
      buttons: [],
      example: template.variavel?.variaveis.map(va => ({
        id: va.id,
        tipo: 'EXAMPLE_URL',
        campo: 'BODY_TEXT',
        valor: va.variavel,
        ordem: va.numero,
        campoFixo: va.tipoCampoFixo || null
      } as TemplateComponenteExemploModel))
    }

    if(!ehSms && template.textoRodape){
      rodape = {
        id: template.idRodape,
        type: 'FOOTER',
        format: undefined,
        text: template.textoRodape,
        buttons: [],
        example: []
      }
    }

    // @ts-expect-error cabecalho pode não ter sido atribuído quando o template não possui cabeçalho
    if(cabecalho)
      this.components.push(cabecalho);
    this.components.push(corpo);
    // @ts-expect-error botao pode não ter sido atribuído quando o template não possui botões
    if(botao)
      this.components.push(botao);
    // @ts-expect-error rodape pode não ter sido atribuído quando o template não possui rodapé
    if(rodape)
      this.components.push(rodape);

    if(!ehSms && template.conta)
      this.conta = template.conta;

    return this;
  }

  static fromSmsBackend(raw: any): TemplateSalvamentoModel {
    const model = new TemplateSalvamentoModel();
    if (!raw) {
      return model;
    }

    model.id = raw.id ?? null;
    model.name = raw.nome ?? raw.name;
    model.tipo = raw.tipo ?? 'SMS';
    model.category = raw.categoria ?? raw.category;
    model.language = raw.idioma ?? raw.language;
    model.status = raw.status;

    const componentes = raw.componentes ?? raw.components ?? [];
    model.components = componentes.map((comp: any, indice: number) => ({
      id: indice,
      type: comp.tipo ?? comp.type,
      format: comp.formato ?? comp.format,
      text: comp.texto ?? comp.text,
      buttons: [],
      example: (comp.exemplos ?? comp.example ?? []).map((ex: any) => ({
        id: ex.ordem ?? ex.id,
        campo: ex.campoExemplo ?? ex.campo ?? null,
        valor: ex.valor ?? null,
        tipo: ex.tipo ?? null,
        ordem: ex.ordem ?? null,
        urlImagem: ex.urlImagem
      }))
    }));

    return model;
  }

}
